// extracted by mini-css-extract-plugin
export default {"container":"TrainingClassHeader-module__container","title":"TrainingClassHeader-module__title","offlineIndicator":"TrainingClassHeader-module__offlineIndicator"};